"use client";

import { useState } from "react";
import { Button } from "@focal/ui-kit";
import { Input } from "@focal/ui-kit";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@focal/ui-kit";
import { Label } from "@focal/ui-kit";
import { Checkbox } from "@focal/ui-kit";
import { useSessionContext } from "@/context";
import { FeatureFlagName } from "@/types/feature-flag";

type ClientType = "crm" | "normal";

interface DeleteClientModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: (removeFromCrm?: boolean) => void;
  clientName: string;
  clientType: ClientType;
}

export const DeleteClientModal = ({
  isOpen,
  onClose,
  onDelete,
  clientName,
  clientType,
}: DeleteClientModalProps) => {
  const [confirmText, setConfirmText] = useState("");
  const [confirmCrmText, setConfirmCrmText] = useState("");
  const [deleteCrmUser, setDeleteCrmUser] = useState(false);
  const isDeleteEnabled =
    confirmText.toLowerCase() === "delete" &&
    (!deleteCrmUser || confirmCrmText.toLowerCase() === "delete in crm");
  const handleDelete = () => {
    if (isDeleteEnabled) {
      onDelete(deleteCrmUser);
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Delete client</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete the client &quot;{clientName}&quot;?
            This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col space-y-4">
          <div className="flex flex-col space-y-2">
            <Label htmlFor="confirm-delete">
              Type &quot;Delete&quot; to confirm:
            </Label>
            <Input
              id="confirm-delete"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              className="col-span-3"
              placeholder="Delete"
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="destructiveOutline"
            onClick={handleDelete}
            disabled={!isDeleteEnabled}
          >
            Delete Client
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
